
import React, { useEffect, useState } from "react";
import { fetchLifestyle } from "./LifestyleQuery";
import "./Lifestyle.css";
import "../../styles/common.css";

const BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

const Lifestyle = () => {
  const [title, setTitle] = useState("");
  const [lifestyleSections, setLifestyleSections] = useState([]);
  const [loading, setLoading] = useState(true);

  const getFullUrl = (url) =>
    url?.startsWith("http")
      ? encodeURI(url)
      : `${BASE_URL}${encodeURI(url)}`;

  useEffect(() => {
    async function loadData() {
      try {
        const data = await fetchLifestyle();
        const homePageData = data?.homePage?.[0];

        setTitle(homePageData?.lifestyleTitle || "The CafeGP Lifestyle");

        const items =
          homePageData?.lifestyle?.contentItems?.filter((item) => item.enabled) ||
          [];

        setLifestyleSections(items);
      } catch (err) {
        console.error("Error loading Lifestyle:", err);
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, []);

  //if (loading) return <p>Loading...</p>;

  return (
    <div className="lifestyle-container">
      <h2 className="lifestyle-title">{title}</h2>

      <div className="lifestyle-sections">
        {lifestyleSections.length > 0 ? (
          lifestyleSections.map((section, index) => (
            <div className="lifestyle-card" key={index}>
              {section.icon?.urls?.[0] && (
                <img
                  src={getFullUrl(section.icon.urls[0])}
                  alt={section.title || `Lifestyle-${index + 1}`}
                  className="lifestyle-icon"
                />
              )}
              <h3>{section.title}</h3>
              <p>{section.text}</p>
            </div>
          ))
        ) : (
          <p className="no-items">No lifestyle items available.</p>
        )}
      </div>
    </div>
  );
};

export default Lifestyle;
